<template>
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
			</div>
			<div class="pull-right">
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print"></i> {{ $t('Печать')}}
				</b-button>
			</div>
			<div class="clearfix"></div>
		</div>
		<div class="doc-body">
			<b-card style="padding-top: 40px; padding-left: 50px; padding-right: 20px; padding-bottom: 20px">
				<b-row>
					<b-col align="center"><b>Документ № </b> <span> {{doc.regNumber}}</span></b-col>
					<b-col align="center"><b>Дата: </b> <span> {{doc.regDate}}</span></b-col>
					<b-col align="center"><b>Откуда: </b> <span> {{doc.fromDepartmentName}}</span></b-col>
					<b-col align="center"><b>Кому: </b> <span v-for="(emp,index) in doc.brigadeDtos" :key="`emp-${index}`">{{ emp.name + ` -- ${getEmployeeFullName(emp)}` }}<br></span></b-col>
				</b-row>
				<table style="width: 100%">
					<tbody>
					<tr>
						<td>
							<div class="mb-3" id="nakladnoyTableWrapper">
								<table class="table table-striped" id="tableForExcel" style="font-size: 15px">
									<tr id="dutyFreeItemsHeader">
										<th class="p-1 textAlignCenter" style="width: 3%">№</th>
										<th class="p-1 textAlignCenter">Спец-код</th>
										<th class="p-1">Наименование</th>
										<th class="p-1 text-center" style="width: 10%">Штрих-код</th>
										<th class="p-1 textAlignCenter">Кол-во</th>
										<th class="p-1 textAlignCenter">Продано</th>
										<th class="p-1 textAlignCenter">Приход (остатка)</th>
										<th class="p-1 textAlignCenter">Цена</th>
										<th class="p-1 textAlignCenter">Сумма <sup>(Кол-во)</sup></th>
										<th class="p-1 textAlignCenter">Сумма <sup>(Продано)</sup></th>
									</tr>
									<tbody>
									<tr v-for="(item, index) in doc.whItems" class="docItemRow" :key="index">
										<td class="text-center">{{ index + 1 }}</td>
										<td class="text-center">{{ item.barcode }}</td>
										<td>{{ item.itemName }}</td>
										<td class="text-center">
											<p v-for="(barcode, k) in item.multiBarcodes" :key="k">{{ barcode.barcode }}</p>
										</td>
										<td class="customSizeItem text-center">
											{{ item.count }} <sup>{{ item.unitName }}</sup>
										</td>
										<td class="customSizeItem text-center">
											{{ item.skyQty ? item.skyQty : '' }} <sup v-if="item.skyQty">{{ item.unitName }}</sup>
										</td>
										<td class="customSizeItem text-center">
											{{ item.count - (item.skyQty ? item.skyQty : 0) }} <sup>{{ item.unitName }}</sup>
										</td>
										<td class="text-center">
											{{ item.priceUzs | currency({ symbol: ' ', fractionCount: 2, symbolPosition: 'back' }) }}
										</td>
										<td class="text-center">
											<span class="text-center">{{ (item.priceUzs * item.count) | currency({ symbol: 'EUR', fractionCount: 2, symbolPosition: 'back' }) }}</span>
										</td>
										<td class="text-center">
											<span class="text-center">{{ (item.priceUzs * item.skyQty) | currency({ symbol: 'EUR', fractionCount: 2, symbolPosition: 'back' }) }}</span>
										</td>
									</tr>
									</tbody>
									<tr>
										<td colspan="4" style="font-weight: bold; text-align: right">Итого</td>
										<td class="text-center">
											<span style="font-weight: bold">{{ totalCountItems }}</span>
										</td>
										<td class="text-center">
											<span style="font-weight: bold">{{ totalSkyQtyItems }}</span>
										</td>
										<td class="text-center">
											<span style="font-weight: bold">{{ totalCountSkyQtyItems }}</span>
										</td>
										<td/>
										<td class="text-center">
											<span style="font-weight: bold">
												{{ totalPriceOfItems | currency({ symbol: 'EUR', fractionCount: 2, symbolPosition: 'back' }) }}
											</span>
										</td>
										<td class="text-center">
											<span style="font-weight: bold">
												{{ totalPriceOfSkyQtyItems | currency({ symbol: 'EUR', fractionCount: 2, symbolPosition: 'back' }) }}
											</span>
										</td>
									</tr>
								</table>
								<div v-if="loading" class="spinner-wrapper">
									<b-spinner variant="primary"></b-spinner>
								</div>
							</div>
						</td>
					</tr>
					</tbody>
					<tfoot class="nakladnoyFooter">
					<tr>
						<td>
							<table style="width: 100%;">
								<tr>
									<td colspan="2">Требование составил _______________________________</td>
									<td>"Утверждаю"</td>
								</tr>
								<tr>
									<td>Отпустил ______________________________</td>
									<td>Принял ______________________________</td>
									<td>______________________________</td>
								</tr>
								<tr>
									<td colspan="2"></td>
									<td>Yusupova R.A.</td>
								</tr>
								<tr>
									<td colspan="2"></td>
									<td>______________________________</td>
								</tr>
								<tr>
									<td colspan="2">Сотрудник т/п №1 СТК "Ташкент АЭРО"</td>
									<td>Zakirov O. Z.</td>
								</tr>
								<tr>
									<td colspan="2" class="text-right">______________________________</td>
									<td>______________________________</td>
								</tr>
								<tr>
									<td colspan="2" class="text-right">Ф.И.О</td>
									<td><div class="row">
										<div class="col-6 ">подпись</div>
										<div class="col-6 "></div>
									</div></td>
								</tr>
							</table>
						</td>
					</tr>
					</tfoot>
				</table>
			</b-card>
		</div>
	</div>
</template>

<script>
import SkyShopService from "./skyshop.service";

export default {
	name: "skyDocNakladnoy",
	data() {
		return {
			doc: {},
			loading: false
		}
	},
	computed: {
		totalCountItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=item.count
			})
			return sum
		},
		totalSkyQtyItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=(item.skyQty?item.skyQty:0)
			})
			return sum
		},
		totalCountSkyQtyItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=(item.count-(item.skyQty?item.skyQty:0))
			})
			return sum
		},
		totalPriceOfItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=(item.count*item.priceUzs)
			})
			return sum
		},
		totalPriceOfSkyQtyItems() {
			let sum = 0
			this.doc.whItems.forEach(item => {
				sum+=((item.skyQty?item.skyQty:0)*item.priceUzs)
			})
			return sum
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},
		getEmployeeFullName(brigade) {
			let name = ''
			brigade.employeeDtos.forEach(t => {
				name+= ` ${t.lastName} ${t.firstName} ${t.middleName}`
			})
			return name;
		},
		getDoc() {
			this.loading = true
			SkyShopService.getDocById(this.$route.params.id).then(res => {
				this.loading = false
				this.doc = res.data
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		}
	},
	created() {
		this.getDoc();
	}
}
</script>

<style scoped>
@page  {
	margin: 1cm;
}
@media print {
	.hidden-print {
		display: none;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	#nakladnoyTableWrapper {
		display: block;
	}
}
</style>
